export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          手机端入口
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          随时随地，黑料不错过
        </p>
        <div className="bg-background-50 border border-background-200/60 rounded-lg p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-shrink-0">
              <div className="relative w-[200px] h-[360px] bg-background-200 rounded-2xl border-4 border-background-300/60 overflow-hidden">
                <div className="absolute top-0 left-0 right-0 h-8 bg-background-300/40 rounded-t-xl flex items-center justify-center">
                  <div className="w-16 h-1.5 rounded-full bg-background-400/50"></div>
                </div>
                <div className="pt-10 px-4">
                  <div className="flex items-center gap-2 mb-5">
                    <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                      <i className="ri-fire-line text-sm text-white"></i>
                    </div>
                    <span className="text-xs font-bold text-foreground-200">黑料入口</span>
                  </div>
                  <div className="space-y-2.5">
                    <div className="h-3 bg-background-300/50 rounded w-3/4"></div>
                    <div className="h-3 bg-background-300/50 rounded w-full"></div>
                    <div className="h-3 bg-background-300/50 rounded w-5/6"></div>
                  </div>
                  <div className="mt-4 space-y-2">
                    <div className="h-10 bg-primary-500/20 rounded-md border border-primary-500/30"></div>
                    <div className="h-10 bg-background-200 rounded-md border border-background-300/50"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-lg md:text-xl font-semibold text-foreground-100 mb-4 font-heading">
                黑料入口移动端 · 吃瓜随时随地
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                黑料入口移动端适配手机浏览，让你在地铁上、午休时、睡前都能快速浏览最新黑料故事。优化过的移动端体验确保在任何屏幕尺寸下都能流畅阅读黑料揭秘和瓜田动态。
              </p>
              <p className="text-sm text-foreground-400 leading-relaxed mb-6">
                无需下载安装，通过手机浏览器访问黑料网网址即可获得完整的黑料吃瓜网站体验。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="px-6 py-3 bg-background-200 border border-background-300/60 rounded-lg flex items-center gap-2 cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-smartphone-line text-lg text-foreground-300"></i>
                  <span className="text-sm text-foreground-300 whitespace-nowrap">浏览器直接访问</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}